export const is404Error = (error: unknown): boolean => {
  const STATUS_404 = 404;

  if (typeof error === 'object' && error !== null && 'response' in error) {
    const response = error.response;
    if (typeof response === 'object' && response !== null && 'status' in response) {
      const status = response.status;
      if (status === STATUS_404) {
        return true;
      }
    }
  }
  return false;
};

